/**
 * Event binding for the Story Authoring panel.
 * Rendering remains in index.js until the later UI/render split is complete.
 */
export function bindAuthoringPanelControls(
  callbacks = {},
  documentRef = document
) {
  const btn = documentRef.getElementById('authorModeBtn')
  const clearBtn = documentRef.getElementById('clearSelectionBtn')
  const summarizeBtn = documentRef.getElementById('summarizeSelectionBtn')
  const saveBtn = documentRef.getElementById('saveDraftBtn')
  const downloadBtn = documentRef.getElementById('downloadAnnotationsBtn')
  const importBtn = documentRef.getElementById('importAnnotationsBtn')
  const importInput = documentRef.getElementById('importAnnotationsInput')
  const layerSelect = documentRef.getElementById('authoringLayerSelect')
  const addLayerBtn = documentRef.getElementById('addAuthoringLayerBtn')
  const savedList = documentRef.getElementById('savedSnippetsList')

  if (btn && callbacks.onToggleAuthoring) {
    btn.addEventListener('click', callbacks.onToggleAuthoring)
  }
  if (clearBtn && callbacks.onClearSelection) {
    clearBtn.addEventListener('click', callbacks.onClearSelection)
  }
  if (summarizeBtn && callbacks.onSummarize) {
    summarizeBtn.addEventListener('click', callbacks.onSummarize)
  }
  if (saveBtn && callbacks.onSaveDraft) {
    saveBtn.addEventListener('click', callbacks.onSaveDraft)
  }
  if (downloadBtn && callbacks.onDownload) {
    downloadBtn.addEventListener('click', callbacks.onDownload)
  }
  if (importBtn && importInput) {
    importBtn.addEventListener('click', () => importInput.click())
  }
  if (importInput && callbacks.onImportFile) {
    importInput.addEventListener('change', event => {
      const file = event.target.files && event.target.files[0]
      callbacks.onImportFile(file)
      event.target.value = ''
    })
  }
  if (layerSelect && callbacks.onSwitchLayer) {
    layerSelect.addEventListener('change', event =>
      callbacks.onSwitchLayer(event.target.value)
    )
  }
  if (addLayerBtn && callbacks.onAddLayer) {
    addLayerBtn.addEventListener('click', callbacks.onAddLayer)
  }
  if (savedList) {
    savedList.addEventListener('click', event => {
      const saveEditButton = event.target.closest('.save-snippet-edit-btn')
      if (saveEditButton && callbacks.onSaveSnippetEdit) {
        const row = saveEditButton.closest('.authoring-saved-row')
        callbacks.onSaveSnippetEdit(
          saveEditButton.getAttribute('data-snippet-id'),
          {
            label:
              row &&
              row.querySelector('.saved-snippet-label-input') &&
              row.querySelector('.saved-snippet-label-input').value,
            paragraph:
              row &&
              row.querySelector('.saved-snippet-paragraph-input') &&
              row.querySelector('.saved-snippet-paragraph-input').value,
            color:
              row &&
              row.querySelector('.saved-snippet-color-input') &&
              row.querySelector('.saved-snippet-color-input').value,
          }
        )
        return
      }
      const cancelEditButton = event.target.closest('.cancel-snippet-edit-btn')
      if (cancelEditButton && callbacks.onCancelSnippetEdit) {
        callbacks.onCancelSnippetEdit()
        return
      }
      const editButton = event.target.closest('.edit-snippet-btn')
      if (editButton && callbacks.onEditSnippet) {
        callbacks.onEditSnippet(editButton.getAttribute('data-snippet-id'))
        return
      }
      const removeButton = event.target.closest('.remove-snippet-btn')
      if (removeButton && callbacks.onRemoveSnippet) {
        callbacks.onRemoveSnippet(removeButton.getAttribute('data-snippet-id'))
        return
      }
      if (
        event.target.closest(
          '.saved-band-color-input, .saved-snippet-label-input, .saved-snippet-paragraph-input, .saved-snippet-color-input'
        )
      ) {
        return
      }
      const row = event.target.closest('.authoring-saved-row')
      if (!row || !callbacks.onNavigateSnippet) return
      if (row.classList.contains('is-editing')) return
      callbacks.onNavigateSnippet(row.getAttribute('data-snippet-id'))
    })
    if (callbacks.onBandColorChange) {
      savedList.addEventListener('change', event => {
        const input = event.target.closest('.saved-band-color-input')
        if (!input) return
        callbacks.onBandColorChange(
          input.getAttribute('data-band-id'),
          input.value
        )
      })
    }
  }
}
